<template lang="html">  
    <div class="row">
        <div class="col-12 grid-margin">
            <div class="card">
                <div class="card-body">
                    <form class="forms-sample">
                        <div class="row">
                            <div class="col-md-6">
                                <b-form-group label="Restaurant Name">
                                    <b-form-input v-model="restaurant.restaurantName" 
                                          type="text" 
                                          placeholder="Name">
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-6">
                                <b-form-group label="Organizational No">
                                    <b-form-input v-model="restaurant.organizationNumber" 
                                          type="text" 
                                          placeholder="Organizational Number">
                                    </b-form-input>
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <b-form-group label="Type">
                                    <b-form-select class="mb-3"
                                                    text-field="name"
                                                    value-field="restaurantTypeId" 
                                                    :options="restauranttypes"
                                                    v-model="restaurant.restaurantTypeId"/>
                                </b-form-group>
                            </div>
                        </div>
                        <b-form-group label="Description">
                            <b-form-textarea v-model="restaurant.description" 
                                             :rows="3"
                                             :max-rows="6"
                                             placeholder="Description">
                            </b-form-textarea>
                        </b-form-group>
                        <div class="row">
                            <div class="col-md-6">
                                <b-form-group label="Address">
                                    <b-form-input v-model="restaurant.address" 
                                          type="text" 
                                          placeholder="Address">
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-6">
                                <b-form-group label="City">
                                    <b-form-input v-model="restaurant.city" 
                                          type="text" 
                                          placeholder="City">
                                    </b-form-input>
                                </b-form-group>
                            </div>
                        </div>
                       <div class="row">
                            <div class="col-md-6">
                                <b-form-group label="Post Number">
                                    <b-form-input v-model="restaurant.postNumber" 
                                          type="text" 
                                          placeholder="Post Number">
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-6">
                                <b-form-group label="Phone Number">
                                    <b-form-input v-model="restaurant.phoneNumber" 
                                          type="text" 
                                          placeholder="Phone Number">
                                    </b-form-input>
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <b-form-group label="Restaurant Image">
                                    <image-uploader
                                        :imageUrl="restaurant.imageUrl" 
                                        @ready-upload="handleReadyUpload"
                                    />
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <b-form-group label="In Active">
                                    <b-form-checkbox v-model="restaurant.inActive" switch>
                                        <b v-if="restaurant.inActive">Restaurant is closed</b>
                                    </b-form-checkbox>
                                </b-form-group>
                            </div>
                        </div>
                        <div class="container-fluid mt-5 w-100">
                            <hr>
                            <b-button variant="success" 
                                  class="mr-2"
                                  v-on:click="handleBtnSave">
                                  Save
                            </b-button>
                            <b-button variant="light" 
                                  v-on:click="handleBtnCancel">
                                  Cancel
                            </b-button>
                        </div>
                    </form>
                </div>
            </div>
        </div>      
    </div>
</template>

<script lang="js">
import { mapState } from'vuex'
import ImageUploader from '../Bases/ImageUploader'
export default{
    name: 'restauranteditform',
    inject: ['eventBus'],
    components: {
        ImageUploader
    },
    data () {
        return {
            restaurant: {
                restaurantId: '',
                restaurantName: '',
                organizationNumber: '',
                description: '',
                address: '',
                phoneNumber: '',
                city: '',
                postNumber: '',
                imageUrl: '',
                inActive: ''
            },
            imagesForUpload: []
        }
    },
    computed: {
        ...mapState({
            restaurants: state => state.restaurants.restaurants,
            restauranttypes: state => state.restauranttypes.restauranttypes
        })
    },
    methods : {
        async handleBtnSave () {
            let formData = new FormData();
            formData.append('file', this.imagesForUpload);
            await this.$store.dispatch('restaurants/updateRestaurantAction', {'restaurant' : this.restaurant, 'image':formData});
            this.$router.push('/');
        },
        handleBtnCancel () {
            this.$router.push('/');
        },
        handleReadyUpload(file) {
            this.imagesForUpload = file;
        },
        currentRestaurantChangedHanlder () {
            this.restaurant = this.$store.state.restaurants.currentRestaurant;
        }
    }, 
    created() {
        this.$store.dispatch('restauranttypes/getRestaurantTypesAction');
        this.restaurant = this.$store.state.restaurants.currentRestaurant;
    },
    mounted() {
        this.eventBus.$on('currentRestaurantChangedEvent', this.currentRestaurantChangedHanlder);
    },
    destroyed() {
        this.eventBus.$off('currentRestaurantChangedEvent', this.currentRestaurantChangedHanlder); 
    }
}
</script>
